<template>
	<div class="scene-list-wrapper">
		<div class="scene-list-top">
			<div class="scene-list-title">
				<p
					class="s-title text-overflow"
					v-if="sceneInfo.platformInfo&&sceneInfo.platformInfo.platformName"
				>{{sceneInfo.platformInfo.platformName}}</p>
				<div class="tags" v-if="sceneInfo.platformInfo&&sceneInfo.platformInfo.remark">
					<div
						class="tag"
						v-for="(tag,i) of sceneInfo.platformInfo.remark"
						:key="i"
						v-text="tag"
						v-show="tag!=''"
					></div>
				</div>
			</div>
			<div class="scene-weather">
				<img :src="getWeatherIcon(weatherData)" alt="weather-icon" class="weather-icon" />
				<span class="temp">{{weatherData.condition&&weatherData.condition.temp}}°C</span>
			</div>
		</div>
		<van-swipe
			ref="s_b"
			class="swiper-container"
			:width="swipeWidth"
			:autoplay="3000"
			v-show="sceneInfo.rotation&&sceneInfo.rotation.length>0"
			indicator-color="#ffbc00"
		>
			<van-swipe-item v-for="image in sceneInfo.rotation" class="blur-wrapper" :key="image.id">
				<img :width="swipeWidth" :src="image.url" @click.prevent="toUrl(image.link)" />
			</van-swipe-item>
		</van-swipe>
		<div class="scene-intro-wra">
			<div :class="showTotal ? 'total-introduce' : 'detailed-introduce'">
				<div class="intro-content" :title="introduce" ref="desc">
					<span class="merchant-desc" v-if="introduce" v-html="introduce"></span>
					<div class="unfold" @click="showTotalIntro" v-if="showExchangeButton">
						<p class="r">
							{{exchangeButton ? '展开' : '收起'}}
							<img
								class="up-icon"
								:class="{'active':exchangeButton}"
								src="https://oss.tuoxingwang.com/vaporetto-assets/scene/png/down-arrow.png"
								alt="down-icon"
							/>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="shipside">
			<img src="https://oss.tuoxingwang.com/vaporetto-assets/scene/png/shipside.png" alt="img" />
			<span>运营码头</span>
		</div>
		<van-pull-refresh v-model="isLoading" @refresh="pullDownRefresh">
			<img slot="loading" :src="loadingSrc" class="boms-loading-sm" />
			<img slot="normal" :src="loadingSrc" class="boms-loading-sm" />
			<img slot="pulling" :src="loadingSrc" class="boms-loading-sm" />
			<img slot="loosing" :src="loadingSrc" class="boms-loading-sm" />
			<van-list
				v-model="pullUpLoading"
				:finished="isMaxData"
				:immediate-check="false"
				@load="pullUpLoadData"
			>
				<list-of-scene
					v-for="item of sceneListData"
					:key="item.id"
					:item="item"
					@click.native="redirectToSceneDetail(item.id)"
				></list-of-scene>
			</van-list>
		</van-pull-refresh>
		<boms-footer :is-show="isFooterShow" :active="0"></boms-footer>
	</div>
</template>

<script>
import ListOfScene from "@/components/ListOfScene";
export default {
	name: "SceneList",
	components: { ListOfScene },
	props: {},
	data() {
		return {
			introduce: "",
			// 是否展示所有文本内容
			showTotal: true,
			// 显示展开还是收起
			exchangeButton: true,
			// 是否显示展开收起按钮
			showExchangeButton: false,
			isLoading: false,
			pullUpLoading: false,
			isMaxData: false,
			currentPage: 0,
			sceneListData: [],
			numberInEachPage: 10,
			isWXSharePage: true,
			loadingSrc: "",
			weatherData: {},
			swipeWidth: window.innerWidth,
			slideDown: false, //控制是否slideDown
			isFooterShow: true,
			sceneInfo: []
		};
	},
	computed: {},
	activated() {
		this.isWXSharePage = true;
        this.pullDownRefresh();
        wx.ready(function () {
            UTILS.hiddenMenu();
        });
        sessionStorage.setItem("fromHome", "fromHome");
        const shareToName = UTILS.getQueryString("shareto");
		const shareId = UTILS.getQueryString("shareid");
		if (shareToName && sessionStorage.isShareTo) {
            sessionStorage.removeItem("isShareTo");
			if (shareId) {
				this.$router.push(`/${shareToName}/${shareId}`);
			} else {
				this.$router.push(`/${shareToName}`);
			}
		}
	},
	deactivated() {
		this.isWXSharePage = false;
	},
	watch: {
		introduce: function() {
			this.$nextTick(
				function() {
					// 判断介绍是否超过四行
					let rem = parseFloat(this.getRem());
					if (!this.$refs.desc) {
						return;
					}
					let descHeight = window
						.getComputedStyle(this.$refs.desc)
						.height.replace("px", "");
					if (descHeight > 5.25 * rem) {
						// 显示展开收起按钮
						this.showExchangeButton = true;
						this.exchangeButton = true;
						// 不是显示所有
						this.showTotal = false;
					} else {
						// 不显示展开收起按钮
						this.showExchangeButton = false;
						// 没有超过四行就显示所有
						this.showTotal = true;
					}
				}.bind(this)
			);
		}
	},
	created() {
		this.getWeather();
		this.getSceneInfo();
		if (sessionStorage.getItem("firstEnter") == "first") {
			return;
		}
		const shareToName = UTILS.getQueryString("shareto");
		const shareId = UTILS.getQueryString("shareid");
		sessionStorage.setItem("firstEnter", "first");
        sessionStorage.setItem("fromHome", "fromHome");
        wx.ready(function () {
            UTILS.hiddenMenu();
        });
        if (shareToName) {
			if (shareId) {
				this.$router.push(`/${shareToName}/${shareId}`);
			} else {
				this.$router.push(`/${shareToName}`);
			}
		}
	},
	mounted() {
		this.loadingSrc = API.ossUrl + "yyq/loading.gif";
		sessionStorage.showBottomBar = false;
	},
	destroyed() {},
	methods: {
		toUrl(link) {
			if (link) {
				sessionStorage.isShareTo = 1;
				location.href = link;
			}
		},
		showTotalIntro() {
			this.showTotal = !this.showTotal;
			this.exchangeButton = !this.exchangeButton;
		},
		getRem() {
			const defaultRem = 16;
			let winWidth = window.innerWidth;
			let rem = (winWidth / 375) * defaultRem;
			return rem;
		},
		getSceneInfo() {
			let vm = this;
			this.$axios
				.get(window.API.homepage)
				.then(({ data }) => {
					if (data.code == 200) {
						this.sceneInfo = data.data;
						if (
							this.sceneInfo &&
							this.sceneInfo.platformInfo &&
							this.sceneInfo.platformInfo.content
						) {
							this.introduce = this.sceneInfo.platformInfo.content;
						}
					} else {
						console.log(data.msg);
					}
				})
				.catch(function(err) {
					console.log(err);
				});
		},
		getWeather() {
			let vm = this;
			this.$axios
				.get(window.API.getWeather + "/lanzhou")
				.then(function({ data }) {
					if (data.code == 10000) {
						if (data.result && data.result.data) {
							vm.weatherData = data.result.data;
						}
					} else {
						console.log(data.msg);
					}
				})
				.catch(function(err) {
					console.log(err);
				});
		},
		getWeatherIcon(weather) {
			if (weather.forecast) {
				return `https://oss.tuoxingwang.com/vaporetto-assets/weatherIcon/${weather.forecast[1].conditionIdDay}.png`;
			} else {
				return "";
			}
		},
		getSceneDataFromPage(number = 1) {
			return this.$axios.get(
				`${API.scene.list}/${number}/${this.numberInEachPage}`
			);
		},
		//下拉刷新
		pullDownRefresh() {
			let vm = this;
			this.getSceneDataFromPage(1)
				.then(({ data }) => {
					if (data.code == 200) {
						let res = data.data;
						vm.sceneListData = res.list;
						vm.isLoading = false;
						vm.currentPage = 1;
						vm.isMaxData = res.pageNo >= res.pageCount;
						vm.$nextTick(vm.hiddenTag);
						//初始化微信分享
						if (
							this.isWXSharePage &&
							sessionStorage.getItem("title") !==
								`${API.projectName}-${vm.$route.meta.title}`
						) {
							this.isWXSharePage = false;
							window.global.getConfig({
								title: `${API.projectName}-${vm.$route.meta.title}`,
								link: `${window.location.origin}?shareto=${vm.$route.name}`,
								imgUrl: `${
									vm.sceneListData[0]
										? vm.sceneListData[0].img +
										  "?x-oss-process=image/resize,m_fill,h_256,w_256"
										: ""
								}`,
								desc: " "
							});
						}
					} else {
						vm.$toast(data.msg);
					}
				})
				.catch(err => console.log(err));
		},
		//上拉加载
		pullUpLoadData(number) {
			let vm = this;
			if (vm.currentPage == 0) return (vm.pullUpLoading = false);
			this.getSceneDataFromPage(vm.currentPage + 1)
				.then(({ data }) => {
					if (data.code == 200) {
						let res = data.data;
						vm.sceneListData = vm.sceneListData.concat(res.list);
						vm.pullUpLoading = false;
						vm.currentPage = Number(res.pageNo);
						vm.isMaxData = res.pageNo >= res.pageCount;
						vm.$nextTick(vm.hiddenTag);
					} else {
						vm.$toast(data.msg);
					}
				})
				.catch(err => console.log(err));
		},
		redirectToSceneDetail(sceneId) {
			this.$router.push({
				name: "sceneDetail",
				params: { sceneId }
			});
		},
		hiddenTag() {
			let tagArray = [...document.querySelectorAll(".tag")];
			let cw = document.body.clientWidth - 15;
			tagArray.forEach(element => {
				if (element.getBoundingClientRect().right > cw) {
					element.style.visibility = "hidden";
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.scene-list-wrapper {
	min-height: 100%;
	padding-bottom: 2rem;
	.scene-list-top::before {
		position: absolute;
		top: 0;
		left: 0;
		display: block;
		content: "";
		width: 100%;
		height: 8rem;
		background: linear-gradient(
			180deg,
			rgba(255, 188, 0, 1) 0%,
			rgba(255, 255, 255, 1) 100%
		);
		z-index: 0;
	}
	.scene-list-top {
		display: flex;
		justify-content: space-between;
		position: relative;
		padding: 0.426667rem 0.4rem 0;
		.scene-list-title {
			z-index: 1;
		}
		.scene-weather {
			width: 1.013333rem;
			display: flex;
			flex-direction: column;
			z-index: 1;
			margin-right: 0.24rem;
			.temp {
				font-size: 0.64rem;
				font-family: PingFang SC;
				font-weight: 400;
				line-height: 0.533333rem;
				color: $white;
				text-align: center;
			}
			.weather-icon {
				width: 1.013333rem;
				height: 1.013333rem;
				margin-bottom: 0.133333rem;
				margin-left: 0.206667rem;
			}
		}
		.s-title {
			margin-bottom: 0.373333rem;
			font-size: 0.533333rem;
			font-family: PingFang SC;
			font-weight: bold;
			line-height: 0.746667rem;
			color: rgba(51, 51, 51, 1);
		}
		.tags {
			display: flex;
			flex-wrap: wrap;
			margin-top: 0.186667rempx;
			width: 7.786667rem;
			.tag {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: 0.16rem;
				margin-bottom: 0.133333rem;
				padding: 0.106667rem 0.32rem;
				font-size: 0.32rem;
				font-family: PingFang SC;
				font-weight: 400;
				line-height: 0.453333rem;
				color: rgba(51, 51, 51, 1);
				background: rgba(255, 255, 255, 0.3);
				border-radius: 0.32rem 0.32rem 0.32rem 0px;
			}
		}
	}
	.swiper-container/deep/ {
		margin: 0.306667rem auto 0.373333rem;
		width: 9.2rem;
		height: 4rem;
		border-radius: 0.266667rem;
		.van-swipe__indicators {
			right: 0.4rem;
			left: auto;
			transform: translateX(0);
		}
	}
	.scene-intro-wra {
		position: relative;
		padding: 0 0.333333rem 0 0.44rem;
		.title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 0.533333rem;
			.up-icon {
				width: 0.16rem;
				margin-left: 0.173333rem;
				transform: rotate(-90deg);
				transition: transform 0.3s;
				&.active {
					transform: rotate(90deg);
				}
			}
			.l {
				color: #444444;
				font-size: 22px;
				font-weight: bold;
			}
			.r {
				color: #8c8c8c;
				font-size: 12px;
			}
		}
		.scene-intro-content {
			max-height: 1.813333rem;
			transition: max-height 0.3s ease-in-out;
			overflow: hidden;
			font-size: 0.346667rem;
			font-family: PingFang SC;
			font-weight: 400;
			line-height: 0.64rem;
			color: rgba(112, 112, 112, 1);
			&.active {
				max-height: 11rem;
			}
			img {
				margin-right: 0.133333rem;
				vertical-align: text-top;
				width: 0.373333rem;
				height: 0.426667rem;
			}
		}
	}
	.shipside {
		margin-top: 0.853333rem;
		padding-left: 0.4rem;
		img {
			width: 1.013333rem;
			height: 0.56rem;
		}
		span {
			margin-left: 0.213333rem;
			font-size: 0.48rem;
			font-weight: bold;
			line-height: 0.666667rem;
			color: rgba(51, 51, 51, 1);
		}
	}
	.van-pull-refresh {
		width: 100%;
		flex: 1;
	}
}
.total-introduce {
	width: 9.2rem;
	font-size: 0.346667rem;
	font-family: PingFang SC;
	font-weight: 400;
	line-height: 0.64rem;
	color: rgba(112, 112, 112, 1);
	.intro-content {
		position: relative;
		.merchant-desc {
			width: 100%;
			line-height: 21px;
			word-break: break-all;
			word-wrap: break-word;
			white-space: pre-wrap;
			img {
				width: 0.373333rem;
				height: 0.426667rem;
			}
		}
	}
	.unfold {
		display: block;
		z-index: 11;
		float: right;
		width: 1.333333rem;
		height: 0.586667rem;
		img {
			transform: rotate(-180deg);
			vertical-align: text-top;
			width: 0.586667rem;
			height: 0.586667rem;
		}
		.r {
			display: flex;
			width: 1.333333rem;
			color: #ffbc00;
			font-size: 0.32rem;
		}
	}
}
.detailed-introduce {
	width: 9.2rem;
	position: relative;
	font-size: 0.346667rem;
	font-family: PingFang SC;
	font-weight: 400;
	line-height: 0.64rem;
	color: rgba(112, 112, 112, 1);
	.intro-content {
		// 最大高度设为4倍的行间距
		max-height: 1.813333rem;
		line-height: 0.586667rem;
		word-wrap: break-word;
		/*强制打散字符*/
		word-break: break-all;
		background: transparent;
		/*同背景色*/
		color: transparent;
		overflow: hidden;
		z-index: 3;
		.merchant-desc {
			width: 100%;
			line-height: 0.586667rem;
			word-break: break-all;
			word-wrap: break-word;
			white-space: pre-wrap;
			img {
				width: 0.373333rem;
				height: 0.426667rem;
			}
		}
		&:after,
      // 这是展开前实际显示的内容
      &:before {
			content: attr(title);
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			font-size: 0.346667rem;
			font-family: PingFang SC;
			font-weight: 400;
			line-height: 0.586667rem;
			color: rgba(112, 112, 112, 1);
			word-break: break-all;
			word-wrap: break-word;
			white-space: pre-wrap;
			// overflow: hidden;
		}
		// 把最后最后一行自身的上面三行遮住
		&:before {
			display: block;
			overflow: hidden;
			z-index: 1;
			max-height: 1.173333rem;
			background: transparent;
		}
		&:after {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			overflow: hidden;
			/*截取行数*/
			-webkit-line-clamp: 1;
			text-overflow: ellipsis;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
			width: 9.2rem;
			/*行首缩进字符数，值为[(截取行数-1)*尾部留空字符数]*/
			text-indent: -52.3em;
			/*尾部留空字符数*/
			padding-right: 4em;
			color: rgba(112, 112, 112, 1);
			height: 0.586667rem;
			margin-top: 1.173333rem;
			word-break: break-all;
			word-wrap: break-word;
			white-space: pre-wrap;
		}
		.unfold {
			z-index: 11;
			width: 1.333333rem;
			height: 0.586667rem;
			outline: 0;
			position: absolute;
			right: 0;
			bottom: 0rem;
			img {
				vertical-align: text-top;
				width: 0.586667rem;
				height: 0.586667rem;
			}
			.r {
				display: flex;
				width: 1.333333rem;
				color: #ffbc00;
				font-size: 0.32rem;
			}
		}
	}
}
</style>

